import { MenuGroupsState } from 'reducers/menu-groups/menuGroups'

export const getGroups = ({ menuV3Groups }: MenuGroupsState) => menuV3Groups.groups
